var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModalForm',{attrs:{"headline":_vm.headline,"modalType":_vm.modalType,"submitButtonText":"Slett","submitButtonColor":"error"},on:{"submit":_vm.handleSubmit,"close":function($event){return _vm.$emit('close')}}})}
var staticRenderFns = []

export { render, staticRenderFns }